import { useMemo } from 'react';
import { createUseStyles } from 'react-jss';
import { useTranslation } from 'react-i18next';
import { Theme } from '@app/theme';
import { OptionName, usePlan } from '@app/api';
import { IconChip } from '@app/core';

const useStyles = createUseStyles((theme: Theme) => ({
  tagsContainer: {
    width: '100%',
    display: 'flex',
    flexWrap: 'wrap',
    gap: theme.marginBase,
  },
}));

interface Props {
  planId: string;
}

export const OptionsList = (props: Props) => {
  const classes = useStyles();
  const { i18n } = useTranslation();

  const { data: plan } = usePlan(props.planId);

  const optionsProducts = useMemo(() => {
    const optionsList: string[] = [OptionName.NDA_SIGNING];
    const result = [];
    if (plan) {
      for (const planProd of plan.products) {
        if (!planProd.product) {
          continue;
        }
        const isFixedPrice =
          !planProd.sessionLinkId && !planProd.product?.pricePerParticipant;
        const isInList = optionsList.includes(planProd.product?.name);

        if ((isFixedPrice || isInList) && planProd.product?.title) {
          result.push(planProd.product?.title);
        }
      }
    }
    return result;
  }, [plan, i18n]);

  return (
    <div className={classes.tagsContainer}>
      {optionsProducts.map((option) => {
        return <IconChip color="blue" key={option} label={option} />;
      })}
    </div>
  );
};
